import { render, staticRenderFns } from "./OverlayBox.vue?vue&type=template&id=2c5e6663&"
import script from "./OverlayBox.vue?vue&type=script&lang=js&"
export * from "./OverlayBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports